<template>
  <v-card color="white" width="100%">
    <!-- version escritorio -->
    <v-parallax v-if="barraEscritorio" src="..\assets\parallax.png" height="8%">
      <v-card-title class="text-center justify-center py-6">
        <v-row>
          <v-col cols="12" md="12" align="center">
            <div
              v-resize-text="{ ratio: 1.5, minFontSize: '25px', maxFontSize: '50px' }"
              class="font-weight-bold basil--text pt-10"
            >
              Vademecum Natural
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" md="3" align="center">
            <v-btn small @click.stop="dialogo1()" target="_blank" text color="basil">
              Introducción general
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" align="center">
            <v-btn small @click.stop="dialogo2()" target="_blank" text color="basil">
              Uso del vademecum
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" align="center">
            <v-btn small @click.stop="dialogo3()" target="_blank" text color="basil">
              Formas Farmaceuticas
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" align="center">
            <v-btn small @click.stop="dialogo4()" target="_blank" text color="basil">
              Abreviaturas
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn small color="verdewhatsapp" dark @click="whatsapplink()">
              Hacenos tu pedido al: (011) 15 4047 9087
              <v-icon color="white">mdi-whatsapp</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>
    <!-- fin version escritorio -->
    <!-- version movil -->
    <v-parallax v-if="!barraEscritorio" src="..\assets\parallax.png" height="8%">
      <v-card-title class="text-center justify-center py-6">
        <v-row>
          <v-col cols="12" md="12" align="center">
            <div
              v-resize-text="{ ratio: 1.5, minFontSize: '25px', maxFontSize: '50px' }"
              class="font-weight-bold basil--text pt-12"
            >
              Vademecum Natural
            </div>
          </v-col>
          <v-col cols="12" md="3" align="left">
            <v-btn small @click.stop="dialogo1()" target="_blank" text color="basil">
              <v-icon small>mdi-information</v-icon>
              -Introducción general
            </v-btn>
            <v-btn small @click.stop="dialogo2()" target="_blank" text color="basil">
              <v-icon small>mdi-information</v-icon>
              -Uso del vademecum
            </v-btn>
            <v-btn small @click.stop="dialogo3()" target="_blank" text color="basil">
              <v-icon small>mdi-information</v-icon>
              -Formas Farmaceuticas
            </v-btn>
            <v-btn small @click.stop="dialogo4()" target="_blank" text color="basil">
              <v-icon small>mdi-information</v-icon>
              -Abreviaturas
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn
              max-width="325"
              small
              color="verdewhatsapp"
              dark
              @click="whatsapplink()"
            >
              Hace tu pedido! (011) 15 4047 9087
              <v-icon color="white">mdi-whatsapp</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-parallax>
    <!-- fin version movil -->
    <v-card color="white" flat>
      <Principal />
    </v-card>
    <v-card color="white" flat class="text-center justify-center">
      <v-img src="../assets/parallaxinf.png">
        <v-card-text class="text-center justify-center py-6">
          <p>
            <i
              >Todos los derechos reservados<br />
              copyright© 2022</i
            >
          </p>
        </v-card-text>
      </v-img>
    </v-card>

    <!-- dialogointro muestra intro del vademecum -->
    <template>
      <div>
        <v-dialog
          v-model="dialogointroduccion"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="500"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >INTRODUCCIÓN</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogointroduccion = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img src="..\assets\introduccion.png" width="450" height="750">
                <p align="justify">
                  Estimado Profesional: <br />
                  LABORATORIOS SIMILIA se complace en presentarte su Vademécum Natural,
                  respaldado en nuestra trayectoria de más de 50 años en la elaboración de
                  Formulas Naturales. <br />
                  El mismo intenta ser una guía práctica de preparaciones galénicas que te
                  acompañe a la hora de prescribir una receta. <br />
                  Las formulaciones naturales, por definición, consisten en la
                  elaboración, de acuerdo a una prescripción médica críticamente valorada,
                  de un medicamento a la medida del paciente, en un compromiso profesional
                  de mejorar su salud. <br />
                  Con el fin de alcanzar este objetivo, es fundamental la colaboración
                  estrecha entre el médico y el laboratorio. <br />
                  El crecimiento de la industria farmacéutica corporativa diluyó este nexo
                  entre el profesional y la farmacia. Pero la necesidad de prescribir
                  productos, dosis o vías de administración distintas a las
                  comercializadas, continúa siendo una herramienta imprescindible en el
                  tratamiento médico. Por eso, NOSOTROS participamos activamente para
                  llenar este vacío que propone la industria farmacéutica moderna. <br />
                  LABORATORIOS SIMILIA reafirma que su soporte vital se sustenta sobre una
                  sólida estructura interna, humana y tecnológica, que respalda todo el
                  sistema de trabajo, a través de la cual, continuaremos realizando nuevas
                  mejoras, con capacidad, seriedad y responsabilidad, para seguir
                  ofreciendo el mejor servicio. <br />
                  Contamos con recursos y voluntad suficientes para mantener y acrecentar
                  nuestro principal activo, nuestros clientes, sus pacientes, los que a
                  través del transcurso de los años, siguen confiando en nosotros. <br />
                  Saluda atentamente;<br />
                  LABORATORIOS SIMILIA
                </p>
              </v-img>
            </v-alert>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogointroduccionCelu"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="300"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >INTRODUCCIÓN</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogointroduccionCelu = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img src="..\assets\introduccion.png" width="280" height="auto">
                <v-container>
                  <h5 align="justify">
                    Estimado Profesional: <br />
                    LABORATORIOS SIMILIA se complace en presentarte su Vademécum Natural,
                    respaldado en nuestra trayectoria de más de 50 años en la elaboración
                    de Formulas Naturales. <br />
                    El mismo intenta ser una guía práctica de preparaciones galénicas que
                    te acompañe a la hora de prescribir una receta. <br />
                    Las formulaciones naturales, por definición, consisten en la
                    elaboración, de acuerdo a una prescripción médica críticamente
                    valorada, de un medicamento a la medida del paciente, en un compromiso
                    profesional de mejorar su salud. <br />
                    Con el fin de alcanzar este objetivo, es fundamental la colaboración
                    estrecha entre el médico y el laboratorio. <br />
                    El crecimiento de la industria farmacéutica corporativa diluyó este
                    nexo entre el profesional y la farmacia. Pero la necesidad de
                    prescribir productos, dosis o vías de administración distintas a las
                    comercializadas, continúa siendo una herramienta imprescindible en el
                    tratamiento médico. Por eso, NOSOTROS participamos activamente para
                    llenar este vacío que propone la industria farmacéutica moderna.
                    <br />
                    LABORATORIOS SIMILIA reafirma que su soporte vital se sustenta sobre
                    una sólida estructura interna, humana y tecnológica, que respalda todo
                    el sistema de trabajo, a través de la cual, continuaremos realizando
                    nuevas mejoras, con capacidad, seriedad y responsabilidad, para seguir
                    ofreciendo el mejor servicio. <br />
                    Contamos con recursos y voluntad suficientes para mantener y
                    acrecentar nuestro principal activo, nuestros clientes, sus pacientes,
                    los que a través del transcurso de los años, siguen confiando en
                    nosotros. <br />
                    Saluda atentamente;<br />
                    LABORATORIOS SIMILIA
                  </h5>
                </v-container>
              </v-img>
            </v-alert>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- fin de intro -->

    <!-- dialogo usos muestra uso del vademecum -->
    <template>
      <div>
        <v-dialog
          v-model="dialogousodelvademecum"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="520"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >USO DEL VADEMECUM</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogousodelvademecum = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img src="..\assets\introduccion.png" width="480" height="290">
                <p align="justify">
                  El objetivo del Vademecum Natural, es que te sirva de guía y consulta a
                  la hora de prescribir. <br />
                  En él encontraras todas las sustancias que tenemos en nuestro stock,
                  como así también muchas de las fórmulas más usadas por los médicos con
                  los que trabajamos. Haciendo click en los links de cada capítulo, te
                  redireccionaremos a la página de LABORATORIOS SIMILIA, donde tendrás
                  acceso a una base de datos dinámica de sustancias, fórmulas y patologías
                  que faciliten tu búsqueda. Estamos abiertos a recibir tus posibles
                  comentarios, recomendaciones y agregados tanto de sustancias, como de
                  fórmulas, para poder mejorarlo y mantenerlo actualizado.
                </p>
              </v-img>
            </v-alert>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogousodelvademecumCelu"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="300"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >USO DEL VADEMECUM</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogousodelvademecumCelu = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img src="..\assets\introduccion.png" width="280" height="auto">
                <h5 align="justify">
                  El objetivo del Vademecum Natural, es que te sirva de guía y consulta a
                  la hora de prescribir. <br />
                  En él encontraras todas las sustancias que tenemos en nuestro stock,
                  como así también muchas de las fórmulas más usadas por los médicos con
                  los que trabajamos. Haciendo click en los links de cada capítulo, te
                  redireccionaremos a la página de LABORATORIOS SIMILIA, donde tendrás
                  acceso a una base de datos dinámica de sustancias, fórmulas y patologías
                  que faciliten tu búsqueda. Estamos abiertos a recibir tus posibles
                  comentarios, recomendaciones y agregados tanto de sustancias, como de
                  fórmulas, para poder mejorarlo y mantenerlo actualizado.
                </h5>
              </v-img>
            </v-alert>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- fin de usos -->

    <!-- dialogo formasfarma muestra formas farmaceuticas del vademecum -->
    <template>
      <div>
        <v-dialog
          v-model="dialogoformas"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="550"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >FORMAS FARMACEUTICAS</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogoformas = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img
                src="..\assets\FORMAFARMACEUTICACOMP.png"
                height="1200"
                width="500"
                contain
              ></v-img>
            </v-alert>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogoformasCelu"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="300"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >FORMAS FARMACEUTICAS</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogoformasCelu = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img
                src="..\assets\FORMAFARMACEUTICACOMP.png"
                height="700"
                width="280"
                contain
              ></v-img>
            </v-alert>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- fin de formas -->

    <!-- dialogoabreviaturas muestra abreviaturas del vademecum -->
    <template>
      <div>
        <v-dialog
          v-model="dialogoabreviaturas"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="500"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >ABREVIATURAS</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogoabreviaturas = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img src="..\assets\ABREVIATURAS.png" contain></v-img>
            </v-alert>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogoabreviaturasCelu"
          border="top"
          type="info"
          elevation="2"
          color="tiendasimilia"
          width="300"
        >
          <v-card color="tiendasimilia">
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-toolbar-title class="title white--text pl-0"
                >ABREVIATURAS</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn color="white" @click="dialogoabreviaturasCelu = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-alert>
              <v-img
                src="..\assets\ABREVIATURAS.png"
                height="380"
                width="280"
                contain
              ></v-img>
            </v-alert>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <!-- fin de abreviaturas -->
  </v-card>
</template>

<script>
import Principal from "../components/Principal";
import ResizeText from "vue-resize-text";
import VueScreenSize from "vue-screen-size";

export default {
  name: "VadiMain",
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    Principal,
  },
  data() {
    return {
      barraEscritorio: true,
      dialogointroduccion: false,
      dialogousodelvademecum: false,
      dialogoformas: false,
      dialogoabreviaturas: false,
      dialogointroduccionCelu: false,
      dialogousodelvademecumCelu: false,
      dialogoformasCelu: false,
      dialogoabreviaturasCelu: false,
      // dialogonovedades: false,
      // dialogonovedadesCelu: false,
    };
  },
  directives: {
    ResizeText,
  },

  created() {
    this.initialize();
  },

  methods: {
    whatsapplink: function () {
      window.open("https://api.whatsapp.com/send/?phone=5491140479087&text&app_absent=0");
    },

    initialize() {
      if (this.$vssWidth > 600) {
        this.barraEscritorio = true;
      } else {
        this.barraEscritorio = false;
      }
    },

    dialogo1: function () {
      if (this.$vssWidth > 600) {
        this.dialogointroduccion = true;
      } else {
        this.dialogointroduccionCelu = true;
      }
    },

    dialogo2: function () {
      if (this.$vssWidth > 600) {
        this.dialogousodelvademecum = true;
      } else {
        this.dialogousodelvademecumCelu = true;
      }
    },

    dialogo3: function () {
      if (this.$vssWidth > 600) {
        this.dialogoformas = true;
      } else {
        this.dialogoformasCelu = true;
      }
    },

    dialogo4: function () {
      if (this.$vssWidth > 600) {
        this.dialogoabreviaturas = true;
      } else {
        this.dialogoabreviaturasCelu = true;
      }
    },

    // dialogo5: function () {
    //   if (this.$vssWidth > 600) {
    //     this.dialogonovedades = true;
    //   } else {
    //     this.dialogonovedadesCelu = true;
    //   }
    // },
  },
};
</script>

<style>
/* Helper classes */
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>
